export const GITHUB_USERNAME = "umar24nov";

export const SOCIAL_LINKS = {
  email: "mailto:umar24nov@gmail.com",
  github: "https://github.com/umar24nov",
  linkedin: "https://www.linkedin.com/in/mohammadumarfarook",
  resume:
    "https://drive.google.com/file/d/12ItA_6YPw4giluYcBjK7El15Q8Ubi60c/view?usp=drive_link",
};

export const NAV_LINKS = ["About", "Projects", "Skills", "Education", "Contact"];

export const TYPEWRITER_WORDS = [
  "Developer",
  "CS Fresher",
  "Problem Solver",
  "Open Source Enthusiast",
  "ML Explorer",
];

export const FEEDBACK_TYPES = [
  { emoji: "🐛", label: "Bug Report" },
  { emoji: "💡", label: "Suggestion" },
  { emoji: "⭐", label: "Compliment" },
  { emoji: "🤝", label: "Collaborate" },
];
